;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.creditnote.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = [ '$stateProvider' ]

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'creditnote.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'AVOIRS',
      resolve: {
        pagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('creditNoteList')
        } ],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('creditnote', 'model'))
            .then(function (data) {
              return data.data
            })
        }],
        linkedSearch: [ '$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch
        } ],
        referers: ['UserManager', function (UserManager) {
          return UserManager.getReferers().then(function (data) {
            return data.data
          })
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/creditnote/list/templates/creditnote-list.template.html',
          controller: 'CreditNoteListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/creditnote/list/templates/creditnote-list-toolbar.template.html',
          controller: 'CreditNoteListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Avoirs'
      }
    }
    $stateProvider
      .state(showState)
  }
})(window.angular)
